import Modal from '@components/atoms/modals/Modal';
import { ModalContext } from '@context/modalContext';
import { TitleAndSubtitle } from '@moreharvest/component-library';
import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export interface PrimaryHintModalProps {
    title: React.ReactNode;
    body: React.ReactNode;
}

const PrimaryHintModal = ({ title, body }: PrimaryHintModalProps) => {
    const { pathname } = useLocation();
    const { setModal } = useContext(ModalContext);
    const initialPathRef = useRef(pathname);

    useEffect(() => {
        // Only close modal on route change, not on initial mount
        if (pathname !== initialPathRef.current) {
            setModal(null);
        }
    }, [pathname, setModal]);

    return (
        <Modal>
            <TitleAndSubtitle size="medium" title={title} subtitle={body} />
        </Modal>
    );
};

export default PrimaryHintModal;
